// extracted by mini-css-extract-plugin
module.exports = {"Badge":"Badge_Badge__3--II","Root__standalone":"Badge_Root__standalone__3A5J6"};